import { Grid, Typography } from "@mui/material";
import {
  learnDataCompany,
  resourcesDataCompany,
} from "@/utils/staticData/resourcesData";

import InfoCard from "../UI-Kit/InfoCard";
import BecomeDealer from "./BecomeDealer";
import Section from "../Section";

const ResourcesList = () => {
  return (
    <Section pt={{ xs: 0, md: 3, lg: 13.75 }} pb={{ xs: 10, lg: 16.5 }}>
      <Typography color="text.primary" variant="h1" mb={2}>
        <Typography variant="h1" color="text.accent" component="span">
          Trackmate{" "}
        </Typography>
        Resources
      </Typography>

      <Typography
        variant="subtitle1"
        color="text.secondary"
        mb={{ xs: 5, md: 9, lg: 11.75 }}
      >
        Discover the power of Trackmate and navigate your journey with
        confidence.
      </Typography>

      {/* Company routes */}
      <Typography variant="h2" mb={{ xs: 2, md: 5 }} color="text.primary">
        Company
      </Typography>
      <Grid container spacing={{ xs: 2, lg: 3, xl: 4 }} mb={5}>
        {resourcesDataCompany.map((item, index) => (
          <Grid key={index} item xs={12} md={4}>
            <InfoCard {...item} />
          </Grid>
        ))}
      </Grid>

      <BecomeDealer />

      {/* Learn routes */}
      <Typography variant="h2" mb={{ xs: 2, md: 5 }} color="text.primary">
        Learn
      </Typography>
      <Grid container spacing={{ xs: 2, lg: 3, xl: 4 }}>
        {learnDataCompany.map((item, index) => (
          <Grid key={index} item xs={12} md={6}>
            <InfoCard {...item} />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
};

export default ResourcesList;
